import PickStatusModal from '@/components/modals/PickStatusModal';
import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { StageType } from '@/enums/stageType.enum';
import { Successes } from '@/enums/successes.enum';

import { notificationsMixin } from '../notifications';

export const procedureManageMixin = {
  mixins: [notificationsMixin],
  components: { Panel, PickStatusModal },
  data() {
    return {
      showStatusPicker: false,
      statusPickerProcedure: null,
      statusPickerProcedureId: null
    };
  },
  methods: {
    // @vuese
    // Przenosi do edycji
    goToEdit(procedureId) {
      this.$router.push({ name: 'procedureEdit', params: { procedureId } });
    },

    // @vuese
    // Otwiera modal wyboru statusu
    openStatusPicker(procedure) {
      this.$store
        .dispatch('status/list', { type: StageType.PROCEDURE, templateId: procedure.templateId })
        .then(() => {
          this.showStatusPicker = true;
          this.statusPickerProcedure = procedure;
          this.statusPickerProcedureId = procedure.id;
        })
        .catch(err => this.notifyError(Errors.STATUS_CANNOT_LIST));
    },

    // @vuese
    // Zamyka modal wyboru statusu
    closeStatusPicker() {
      this.showStatusPicker = false;
    },

    // @vuese
    // Zapisuje status procedury
    saveStatus(data) {
      this.$store
        .dispatch('procedure/setStatus', data)
        .then(() => {
          this.statusPickerProcedure.statusId = data.statusId;
          this.statusPickerProcedure.status = this.$store.state.status.list.find(status => status.id === data.statusId);
          this.closeStatusPicker();
          this.notifySuccess(Successes.PROCEDURE_SET_STATUS);
          this.afterStatusSave(data);
        })
        .catch(err => this.notifyError(Errors.PROCEDURE_CANNOT_SET_STATUS));
    },

    // @vuese
    // Akcja wykonywana po zapisie statusu
    afterStatusSave(data) {}
  }
};
